webpackJsonp([178698757827068],{

/***/ 683:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"slug":"/404/","langKey":"en"}}

/***/ })

});


// WEBPACK FOOTER //
// path---404-html-9afb230f4d1be55068f6.js